module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-XBold.1d3ed971.woff2";